import { render, staticRenderFns } from "./SearchRfcPatient.vue?vue&type=template&id=07abdc79&scoped=true"
import script from "./SearchRfcPatient.vue?vue&type=script&lang=js"
export * from "./SearchRfcPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abdc79",
  null
  
)

export default component.exports